<template>
  <div>
    <div>
        <div class="pb-2 m-4 d-flex" style="border-bottom: 1px solid #242424;position:relative">
            <h6 class="m-0 text-left pl-4">{{$t('Elastic Reindex')}}</h6>
            </div>
        <div class="d-inline-flex w-100 float-left mt-2 ml-4 mb-3" style="height: 60px !important;">
        <label style="width:25%;text-align:end;display: flex;justify-content:flex-end" class="text-color">{{$t('Update Elastic DB by')}} </label>
        <div style="display:inline-block;text-align: initial;margin-inline-start: 10px;width:75%">
          <div>
            <div>
              <div class="d-inline-flex w-25" style="align-items: center;margin-bottom:15px">
                <input type="radio" value="path" v-model="filterType" class="bg-transparent border rounded text-light bigger-checkboxes" name="file path"/>
                <label class="filter-label">{{$t('Path')}}</label>
              </div>
              <template v-if="filterType=='path'">
                <div style="padding-inline-start: 25px;margin: 0px 0px 14px 0px;" >
                  <div class="d-inline-flex" style="width:15%">
                    <input type="radio" value="catalog_id_path" v-model="pathTypesStrategy" class="bg-transparent border rounded text-light bigger-checkboxes" name="catalog path"/>
                    <label class="filter-label">{{$t('Catalog')}}</label>
                  </div>
                  <div class="d-inline-flex" style="width:15%">
                    <input type="radio" value="bin_id_path" v-model="pathTypesStrategy" class="bg-transparent border rounded text-light bigger-checkboxes" name="folder path"/>
                    <label class="filter-label">{{$t('Bin')}}</label>
                  </div>
                </div>
                <div style="display:block; text-align: initial; margin: 0px 0px 10px 27px;" v-if="pathTypesStrategy == 'catalog_id_path'">
                  <div class="ml-4 d-inline-flex" style="width:100%;margin-bottom:10px;align-items:center">
                    <!-- <div class="config-desc"> Catalog name :</div> -->
                    <input v-if="selectedCategoryName && selectedCategoryName.length" type="text" :value="selectedCategoryName" 
                     :title="selectedCategoryName" :style="{width:((selectedCategoryName.length+1)*8) + 'px'}"
                     class="rounded text-light non-editable-field text-light pl-2" placeholder="select catalog path"/>
                    <span v-else class="empty-field-text-styles mr-2">NONE</span>
                    <browse-icon v-on:click.native="openCatalogBrowser()" style="height:26px;margin-inline-start:10px;position: relative;"></browse-icon>
                  </div>
                  <div class="ml-4 d-inline-flex" v-if="selectedCategoryName && selectedCategoryName.length" style="width:90%;margin-bottom:10px;line-break: anywhere;">
                    <div class="config-desc"> Path </div>
                    <span style="color: #f8f9fa!important;">{{ getCatalogParentPath() }}</span>
                  </div>
                </div>
                <div style="display: block; text-align: initial; margin: 0px 0px 10px 27px;" v-if="pathTypesStrategy == 'bin_id_path'">
                  <div class="ml-4 d-inline-flex" style="width:100%;align-items:center">
                    <!-- <div class="config-desc"> Folder: </div> -->
                    <input v-if="folderBrowsePath && folderBrowsePath.length" type="text" :value="getFolderNameFromPath(folderBrowsePath)"
                      :title="folderBrowsePath" :style="{width:((getFolderNameFromPath(folderBrowsePath).length+1)*8) + 'px'}" 
                      class="rounded text-light non-editable-field text-light pl-2" placeholder="select folder path"/>
                    <span v-else class="empty-field-text-styles mr-2">NONE</span>
                    <browse-icon v-on:click.native="openFolderBrowser()" style="height:26px;margin-inline-start:3px;position: relative;"
                     title="Browse Folder"></browse-icon>
                  </div>
                  <div class="ml-4 d-inline-flex" v-if="folderBrowsePath && folderBrowsePath.length" style="width:90%;line-break: anywhere">
                    <div class="config-desc"> {{$t('Path')}} </div>
                    <span style="color: #f8f9fa!important;">{{ getFolderParentPathFromPath(folderBrowsePath) }}</span>
                  </div>
                </div>
              </template>

              <div class="inline-block w-25" style="align-items: center;margin-bottom:15px">
                <input type="radio" value="time" v-model="filterType" class="bg-transparent border rounded text-light bigger-checkboxes" name="time type" style="float:inline-start"/>
                <label class="filter-label">{{$t('Time')}}</label>
              </div>
              <div  >
                <div class="d-inline-flex mb-4" v-if="filterType=='time'" style="width:100%;align-items: center;">
                  <div class="config-desc"> From </div>
                  <Multiselect
                    v-model="filteredTime"
                    :options="filterFromDateList"
                    :searchable="false"
                    :close-on-select="true"
                    :allow-empty="false"
                    @select="handleIndexDateSelection($event)"
                    label="label"
                    deselectLabel=""
                    selectLabel=""
                    selectedLabel=""
                    placeholder="Filter based on time"
                    style="width:30%;"
                    track-by="type">
                    <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                    <span style="margin-inline-start:12px;">{{ scope.option.label }}</span>
                    </div>
                    <span slot="noResult">No results.</span>
                  </Multiselect>
                  <DatePicker
                    v-if="filteredTime['key'] == 'from'"
                    :range="false"
                    v-model="customDate"
                    @input="handleCustomDateValueChange()"
                    :clearable="false"
                    valueType="format"
                    ref="createdOnSingle"
                    placeholder=''
                    class="text-light date-input-field-style"
                    style="padding: 0px;border-radius: 5px;position:relative;top:0px;width:35px !important"
                  >
                  </DatePicker>
                </div>
              </div>
              <div class="inline-block w-25" style="align-items: center;margin-bottom:15px">
                <input type="radio" value="assetId" v-model="filterType" class="bg-transparent border rounded text-light bigger-checkboxes" name="asset type" style="float:inline-start"/>
                <label class="filter-label">{{$t('Asset')}}</label>
              </div>
              <div class="d-inline-flex mb-4" v-if="filterType=='assetId'" style="width:100%;align-items:center">
                <div class="config-desc"> {{$t('Asset ID')}} </div>
                <input type="text" id="asset_id_value" ref="assetIdRef" v-model="indexByAssetId" placeholder="Enter Asset ID" class="rounded text-light comm-input-field-style" style="width:60% !important"/>
              </div>
              <div class="inline-block w-25" style="align-items: center;margin-bottom:15px">
                <input type="radio" value="fileId" v-model="filterType" class="bg-transparent border rounded text-light bigger-checkboxes" name="file id type" style="float:inline-start;"/>
                <label class="filter-label">{{$t('File')}}</label>
              </div>
              <div class="d-inline-flex mb-4" v-if="filterType=='fileId'" style="width:100%;align-items:center">
                <div class="config-desc"> {{$t('File ID')}} </div>
                <input type="text" id="file_id_value" ref="fileIdRef" v-model="indexByFileId" placeholder="Enter File ID" class="rounded text-light comm-input-field-style" style="width:60% !important"/>
              </div>
            </div>
            <div>
                <div class="search-bar-comm-style">
                  <div v-if="showProgressBar && progressInfo && progressInfo.state == 'QUEUED'" style="height:55px">
                    <img :src="loadingGif" style="height:55px">
                  </div>
                   <div v-if="showProgressBar && progressInfo && progressInfo.state == 'IN_PROGRESS'" class="progress-bar-wrapper">
                          <div v-if="progressInfo.status_info" class="progress-percentage-display">{{Math.round(progressInfo.status_info.progress) + "%"}}</div>
                          <div class="progress">
                              <div class="progress-bar" role="progressbar" :style="{width:progressInfo.status_info.progress + '%'}" :aria-valuenow="progressInfo.status_info.progress" aria-valuemin="0" aria-valuemax="100"></div>
                          </div>
                          <div class="progress-speed-display">
                              {{progressInfo.status_info.updated_assets_count}} / {{progressInfo.status_info.total_assets_count}} {{$t('assets')}}
                          </div>    
                      </div>
                    <button v-if="!showProgressBar" v-on:click="submitElasticReindexAction()" class="btn btn-outline-primary mt-2 mb-2">{{$t('Reindex')}}</button>
                </div>
                <div class="config-desc" style="width: 140vh;text-align:start">
                    {{elasticReindexdescription}}
                </div>
                <div class="config-desc" style="width: 140vh;text-align:start">
                    {{$t('Last reindexed')}}: <span style="color:#9c9c9c;">{{getDateAndTimeInConfiguredFormat(lastReindexedTime)}}</span>
                </div>
                </div>
              </div>
          </div>
        </div>  
    </div>
  
    <bins-browse-modal
      v-if="isFolderModalVisible"
      :workspaceList="browseWorkspaceList"
      :enableAssetMultiSelect="false"
      @close="closeModal"
      @handleFilesBrowse="handleFolderBrowsePath"
      :enableRecursive="false"
      :browseOnlyFolders="true"
      style="z-index:99"
    ></bins-browse-modal>
    <bins-browse-modal
      ref="catalogsBrowseModal"
      v-if="isCatalogModalVisible"
      :workspaceList="catalogWorkspaceList"
      :enableAssetMultiSelect="false"
      @close="closeModal"
      @handleFilesBrowse="handleSelectedCategoryId"
      :enableRecursive="false"
      :browseOnlyFolders="true"
      style="z-index:99"
    ></bins-browse-modal>
    <CustomMessage v-if="enableCustomMessage" v-bind="currentProperties" @close="enableCustomMessage = false" @allowDeletion="enableCustomMessage=false"></CustomMessage>
  </div>
</template>
<script>
import {mapActions, mapMutations} from "vuex";
import Multiselect from 'vue-multiselect';
import DatePicker from "vue2-datepicker";
import Utils from "../../components.utils.js";
import fileBrowseModel from "../files/filesBrowse.vue";
import browseIcon from "../core/InlineBrowseField.vue";
import Constants from "../../components.constants.js";
import CustomMessage from "../actions/customAlertMessage.vue"

export default {
    data(){
        return{
          showProgressBar:false,
          progressInfo:null,
          loadingGif:Utils.getLoadingGif(),
          lastReindexedTime:null,
          elasticReindexdescription:null,
          filterType:null,                     // filter type path/time/assetId/fileId
          pathTypesStrategy:null,              // path startergy folder_id_path/catalog_id_path
          filteredTime:{label:"Last one hour",type:0,key:"last_one_hour"},                    // last 1hr / 24/ 30days
          filterFromDateList:[
            {label:"Last one hour",type:0,key:"last_one_hour"},
            {label:"Last 24 hour",type:1,key:"last_24_hour"},
            {label:"Last 30 days",type:2,key:"last_30_days"},
            {label:"Custom date", type:3,key:"from"}
          ],
          customDate:null,                     // 'from' date
          indexByAssetId:null,                 // asset id 
          indexByFileId:null,                  // file id
          isFolderModalVisible:false,          // folder browser
          folderBrowsePath:null,               // browsed folder name path
          folderIdPath: null,                  // browsed folder id path
          browseWorkspaceList:[Constants.WORKSPACE_BINS],
          isCatalogModalVisible:false,         // catalog browser
          catalogWorkspaceList:[Constants.WORKSPACE_CATALOG],
          browsedCatalogIdPath:null,           // browsed catalog id path for POST API
          selectedCategoryPath:null,           // browsed catalog parent path for display
          selectedCategoryName:null,           // browsed catalog name for display
          displayMessage:null,                 // error message for alert
          enableCustomMessage:false            // pop alert message 
        }
    },
    components:{
      "browse-icon" : browseIcon,
      "bins-browse-modal": fileBrowseModel,
      "Multiselect":Multiselect,
      DatePicker,
      CustomMessage,
    },
    computed:{
      currentProperties() {
        return {"messageTitle":"Elastic Reindex",
                "messageType": "Error:",
                "displayMessage":this.displayMessage,
                "getUserConfirmation":false}
      },
      formattedDateTime(){
        return Utils.getDateTimeFormat(this.lastReindexedTime)
      }
    },
    watch:{
      displayMessage(newVal, oldVal){
        console.log("oldVal",typeof(oldVal))
        if(newVal && newVal.trim().length){
          this.enableCustomMessage = true
        }else{
          this.enableCustomMessage = false
        }
      }
    },
    methods:{
      //filters logic
      handleCustomDateValueChange(){
        if(this.filteredTime.type == 3 && this.customDate){
          this.$set(this.filteredTime, "label", this.customDate)
        }
      },
      getFolderNameFromPath(folderPath){
        if(folderPath){
          return folderPath.substring(folderPath.lastIndexOf('/') + 1);
        }
        return ""
      },
      getFolderParentPathFromPath(folderPath){
        if(folderPath){
          let parentPath = folderPath.substring(0, folderPath.lastIndexOf('/'));
          return parentPath.replace("share://","")
        }
        return ""
      },
      getCatalogParentPath(){
        return this.selectedCategoryPath.replace("catalog://0/","")
      },
      handleIndexDateSelection(event){
        this.filteredTime = event
        if(this.filteredTime.type != 3){
          this.customDate = null
        }
        this.$nextTick(()=>{
          if(this.filteredTime.key == 'from' && this.$refs.createdOnSingle){
            this.$refs.createdOnSingle.openPopup()
          }
        })
      },
      openFolderBrowser(){
        this.isFolderModalVisible = true;
        // this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
      },
      handleFolderBrowsePath(folderInfoList){
        if(folderInfoList && folderInfoList.length > 0){
            this.folderBrowsePath = folderInfoList[0].path;
            this.folderIdPath = folderInfoList[0].parent_id_path;
            this.closeModal();
          }else{
            console.log("Failed to update the browsed folder path:",folderInfoList)
          }
      },
      handleSelectedCategoryId(browsedCatalogs){
        if(browsedCatalogs && browsedCatalogs.length > 0){
            let selectedPath = browsedCatalogs[0]
            let catId = selectedPath.parent_id_path[0]+ "/" + selectedPath._id;
            this.browsedCatalogIdPath = catId;
            this.selectedCategoryPath = selectedPath.parent_path[0].value;
            this.selectedCategoryName = selectedPath.catalog_name;
            this.closeModal();
          }else{
            console.log("Failed to update the browsed catalog path:",browsedCatalogs)
          }
      },
      openCatalogBrowser(){
        this.isCatalogModalVisible = true;
        // this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
      },
      closeModal() {
        this.isFolderModalVisible = false;
        this.isCatalogModalVisible = false;
        // this.$refs.fadeWhenModelOpen.style.opacity = 1;
      },
        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
        ...mapActions("jobs",["createNewJob"]),
        ...mapActions("settings",["getElasticReindexStatus"]),
        elasticReindexStatusFromServer(){ //To GET last reindexed time
          this.getElasticReindexStatus().then((data)=>{
            if(data.last_job_submitted)this.lastReindexedTime = data.last_job_submitted;
            if(data.description)this.elasticReindexdescription = data.description;
            if(data.state && (data.state == 'IN_PROGRESS' || data.state == 'QUEUED')){
              this.showProgressBar = true;
              this.progressInfo = data;
            }
          });
        },
        submitElasticReindexAction(){ //Elastic reindex button click
          let payload = {job_name:'ElasticReindex', index:'all', element_type:'file'}
          if(this.filterType){
            let query = {}
            switch (this.filterType){
              case 'path':{
                if (!this.pathTypesStrategy){
                  this.displayMessage = "Please select the valid path type Catalog/Folder"
                  return
                }
                if(this.pathTypesStrategy == "catalog_id_path"){
                  if(!this.browsedCatalogIdPath){
                    this.displayMessage = "Please select the valid path catalog path"
                    return
                  }
                  query["catalog_id_path"] = this.browsedCatalogIdPath
                }else{
                  if(!this.folderBrowsePath || !this.folderIdPath){
                    this.displayMessage = "Please select the valid path folder path"
                    return
                  }
                  query["bin_id_path"] = this.folderIdPath
                }
                break;
              }
              case 'time':{
                if(!this.filteredTime || !('type' in this.filteredTime)){
                  this.displayMessage = "Please select the valid time"
                  return
                }
                if(this.filteredTime['key'] == 'from'){
                  if(!this.customDate){
                    this.displayMessage = "Please select the valid date"
                    return
                  }
                  query['from_date'] = this.customDate
                  query['to_date'] = Utils.getTodaysDate()
                  // Convert the strings to Date objects
                  const date1 = new Date(query['from_date']);
                  const date2 = new Date(query['to_date']);
                  if(date1 > date2){
                    this.displayMessage = "Reindex is allowed only till the date.\n Please select valid date"
                    return
                  }
                }else{
                  query[this.filteredTime["key"]] = true
                }
                break;
              }
              case 'assetId':{
                query["asset_id"] = this.indexByAssetId
                break;
              }
              case 'fileId':{
                query["file_id"] = this.indexByFileId
                break;
              }
            }
            payload["query"] = query
          }
          this.createNewJob(payload).then((data)=>{
              if(!Utils.isAcceptedStatusCode(data.statusCode)){
                this.$toast.error("Failed");
              }else{
                this.$toast.success("Reindex initiated");
                this.showProgressBar = true;
                this.progressInfo = data;
              }
          });
        },
        handleElasticReindexNotification(notification){
          notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
              if(notification.message && notification.message.job_name == "ElasticReindex"){
                  this.progressInfo = notification.message;
                  if(this.progressInfo.state == 'COMPLETED'){
                    this.showProgressBar = false;
                    this.progressInfo = null;
                    this.elasticReindexStatusFromServer(); //Fetched last reindexed time again
                  }else{
                    this.showProgressBar = true;
                  }
              }
        },
        registerforWebsocketNotifications(){
            this.addWSEventListener({
                eventname:["JOB_STATUS_UPDATE"],
                callback:this.handleElasticReindexNotification,
                parent: "support"})
        },
        unRegisterforWebsocketNotifications(){
            this.removeWSEventListener({
                eventname:["JOB_STATUS_UPDATE"],
                callback:this.handleElasticReindexNotification,
                parent: "support"})
        },
    },
    created(){
      this.elasticReindexStatusFromServer();
      this.registerforWebsocketNotifications();
    },
    beforeDestroy(){
      this.unRegisterforWebsocketNotifications()
    },
}
</script>

<style lang="scss" scoped>
  $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;
    $applied-filter-background: #1c6c8e;
    $applied-filter-text-color: #eee;

.search-bar-comm-style {
  position: relative;
  width:100%;
  select {
    border: $border-color;
    top: 0%;
    inset-inline-start:8%;
    height: 25px;
    padding-inline-start: 3px;
  }
}

.text-color{
  color:$dull-text-color;
  line-height:20px;
}

.config-desc{
  color: $dull-text-color;
  width:100px;
  text-align:end;
  margin-inline-end:8px;
}

.progress-bar-wrapper{
    display: flex;
    width: 100%;
    height: 50px;
    align-items: center;
  .progress-percentage-display{
          font-size: 11px;
  }
  .progress{
      width: 70%;
      background: #292929;
      margin-inline-start: 4px;
      height: 10px;
      margin-top: -3px;
      border-radius: 3px;
  }
  .progress-speed-display{
          font-size: 11px;
          margin-inline-start: 3px;
  }
}
input[type="radio"] {
    /* background-color only for content */
    background-color:$primary-background !important;
  }
  
  /* appearance for checked radiobutton */
  input[type="radio"]:checked {
    background-color: $active-blue !important;
    //background-image: linear-gradient(to bottom, #5294ce, #3176b3) !important;
    background: radial-gradient(circle, $active-blue 40%, $primary-background 49%, $primary-background 100%) !important;
    border: 1px solid $active-blue !important;
  }

input[type="radio"] {
    outline: none !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: inline-block;
    padding: 4px;
    border-radius: 50% !important;
    width: 20px;
    height: 20px;
    border: 1px solid #4a4a4a !important;
}

.non-editable-field{
    border: none !important;
    pointer-events: none;
    cursor: default;
    position: relative;
    // bottom: 4px;
    color: $text-color;
    // min-width: 30%;
    max-width: 60%;
    text-overflow: ellipsis;
}

.empty-field-text-styles{
  color:$none-text-color;
}

.comm-input-field-style{
    background: $primary-background !important;
    width: 100% !important;
    float: inline-start;
    padding: $input-field-padding;
    border: $border-color !important;
    font-size:$input-field-and-label-font-size;
    height: $input-field-height;
}
.date-input-field-style{
    background: $primary-background !important;
    width: 100% !important;
    float: inline-start;
    padding: $input-field-padding;
    // border: $border-color !important;
    font-size:$input-field-and-label-font-size;
    height: $input-field-height;
}
.filter-label{
  position: relative;
  bottom: 1px;
  padding-inline-start:8px;
  margin-bottom:0px !important;
}

::v-deep {
   .multiselect__content-wrapper{
    display:none;
  }
  .multiselect__tag {
      background-color: $primary-background !important;
    }
    .multiselect__tags{
        background: $primary-background !important;
        border: $border-color !important;
    }
    .multiselect__option--highlight {
       background: $bg-color-on-hover !important;
    }
    .multiselect__content {
       background: $secondary-background-color !important;
    }
    .multiselect__input, .multiselect__single {
        background: transparent !important;
        color:$text-color;
    }
    .multiselect__input:focus{
      outline:none;
      box-shadow: none;
    }
    .multiselect__tag-icon{
       color:$text-color !important;
    }
    .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
        background: $bg-color-on-hover !important;
        color:$text-color !important;
    }
    .multiselect__tag-icon:after{
       color:$secondary-text-color  !important;
       font-size: 23px;
    }
    .multiselect *{
        font-size: 12px !important;
        font-family: "Roboto", Arial, sans-serif !important;
    }
    .multiselect__placeholder {
      padding-top: 0px;
     }
    .multiselect{
      color:$text-color !important;
      font-size: $input-field-and-label-font-size !important;
      // min-width: 100%;
      width: auto;
      min-height: 38px;
      height: 38px;
    }
    .multiselect__option--selected{
        background: $bg-color-on-hover !important;
        color: $text-color;
    }
    .multiselect__content-wrapper{
        border: 1px solid $bg-color-on-hover !important;
        position: relative;
        display: block;
        background: $text-color;
        width: 100%;
        max-height: 240px;
        overflow: auto;
        border: 1px solid $text-color;
        border-top: none;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        z-index: 50;
        -webkit-overflow-scrolling: touch;
    }
    .multiselect__select,.multiselect__current,.multiselect__option{
        line-height: 12px !important;
    }
    .multiselect--above .multiselect__content-wrapper{
       background: $secondary-background-color !important;
    }
    .multiselect__tags {
        background: $primary-background!important;
        height: $input-field-height;
        min-height: 38px;
    }
    .page-item.disabled .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none;
        }
        .page-item.active .page-link {
            background-color: $secondary-background-color !important;
            // border: none !important;
            border: $border-color !important;
            color: $active-blue;
            z-index: 0 !important;
        }
        .page-link {
            background-color: $secondary-background-color !important;
            border: $border-color !important;
            // border: none !important;
            color: $text-color;
            padding: 5px !important;
        }
        .page-link:hover {
            background-color: $bg-color-on-hover !important;
        }
        .pagination {
            float: inline-end;
            margin-bottom: 0px !important;
            margin-inline-end: 8px;
        }
        .VuePagination__count {
          color: $secondary-text-color !important;
          margin-bottom: 0px !important;
          font-size: 12px;
          margin-inline-end: 7px;
          margin-top: 1px;
          float: inline-end;
          margin-inline-start: 5px;
          position: relative;
          top:5px;
        }
        .VuePagination__pagination-item {
            font-size: 14px;
            width: 27px;
        }
        .VuePagination__pagination-item-prev-chunk {
            display:none;
        }
        .VuePagination__pagination-item-next-chunk{
            display:none;
        }

        .VuePagination__pagination-item-prev-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page{
            width:50px !important;
        }

        .VuePagination__pagination-item-next-page a:before{
            width:50px;
            content: "next ";
        }

        .VuePagination__pagination-item-prev-page a:after{
            width:50px;
            content: " prev";
        }
        .v-list{
            padding:0px !important;
        }
        .v-list-item{
            text-align: start;
            border: $border-color !important;
            min-height: 37px !important;
            padding: 0 10px !important;
            font-size: 12px !important;
            .v-list-item__title{
                    font-size: 14px !important;
                    color:$text-color !important;
            }
            }
        .v-menu__content{
            width:150px !important;
        }

    .apply-background{
        .mx-input-wrapper{
            display: flex;
            justify-content: flex-start;
            padding-inline-start: 12px;
            background: $applied-filter-background !important;
            color: $applied-filter-text-color !important;
        }
        .mx-datepicker-range{
            .mx-input-wrapper{
                padding-inline-start: 0px;
            }
        }
    }
    .apply-background{
        background: $applied-filter-background !important;
        color: $applied-filter-text-color !important;
        border: 1px solid #229ed2 !important;
        .comm-input-field-style,.selected-tags-style, .multiselect__input{
            background: $applied-filter-background !important;
            color: $applied-filter-text-color !important;
        }
        .multiselect__tags, .mx-input{
            background: $applied-filter-background !important;
        }
        .multiselect__single, .mx-input, .mx-icon-calendar, .mx-icon-clear, button, svg{
            color: $applied-filter-text-color !important;
        }
        .remove-tag{
            svg{
                color: $applied-filter-text-color !important;
            }
        }
        .mx-input{
          background: transparent !important;
          border: 0px;
        }
        .multiselect__select::before{
            border-color: #b8b8b8 transparent transparent !important;
        }
        .multiselect__placeholder, ::placeholder {
            color: #a6a6a6  !important;
        }
        svg{
            fill: #633636
        }
    }
    
    .apply-background:hover{
        svg{
            fill: #eee;
        }
    }
    .theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
        background: $primary-background;
        border-bottom: $border-color;
    }
    .mx-input{
        background-color: $primary-background  !important;
        border: none !important;
        color: $text-color !important;
    }
    .mx-datepicker-main{
        border: $border-color !important;
        background: $secondary-background-color !important;
    }
    .mx-calendar-content .cell:hover{
        background-color: $bg-color-on-hover !important;
    }
    .mx-datepicker-range{
        width:auto;
    }
    .mx-calendar-content .cell:hover {
        color: #000000;
        background-color: #7d99b1;
    }
    .mx-icon-calendar{
        color:$text-color;
    }
    .mx-input:focus{
        outline:none !important;
        box-shadow: none !important;
    }
}
</style>